<template>
  <div style="padding: 3px">
    <b-table sticky-header ref="table1" stacked="lg" striped hover :items="prestazioniItems"
      :fields="headersPrestazioni" :current-page="1" :per-page="100" sort-icon-left head-variant="light"
      class="sa-b-table">

      <template v-slot:cell(appuntamenti)="row">
        <div v-if="!row.item.new" class="ft-pallini">
          <div class="ft-pallino-box">
            <label>Eseguiti</label>
            <span class="ft-pallino ft-pallino-eseguiti">{{ getNumber('ESEGUITO', row.item.appuntamenti) }}</span>
          </div>
          <div class="ft-pallino-box" v-if="completeBookingSsn">
            <label>Prenotati</label>
            <span class="ft-pallino ft-pallino-prenotati">{{ getNumber('PRENOTATO', row.item.appuntamenti) }}</span>
          </div>
          <div class="ft-pallino-box" v-if="completeBookingSsn">
            <label>Ciclo</label>
            <span class="ft-pallino ft-pallino-ciclo">{{ row.item.quantitaErogabile }}</span>
          </div>
        </div>
      </template>
      <template v-slot:cell(quantita)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.quantita" type="number" :disabled="!completeBookingSsn"></b-form-input>
        </div>
        <div v-else>
          <b-form-input v-if="!isRowEdit(row)" v-model="selectedRowEditItem.quantita" type="number"></b-form-input>
          <b-form-input v-else :disabled="true" v-model="row.item.quantita" type="number"></b-form-input>
        </div>
      </template>
      <template v-slot:cell(codicePrestazione)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.codicePrestazione" list="my-list-id" autocomplete="off-codice-prestazione"
            :disabled="true">
          </b-form-input>
        </div>
        <div v-else>
          <div v-if="!isRowEdit(row)">
            <b-form-input v-model="selectedRowEditItem.codicePrestazione" list="my-list-id"
              autocomplete="off-codice-prestazione" :disabled="true"></b-form-input>
          </div>
          <span v-else>
            <b-form-input v-model="row.item.codicePrestazione" :disabled="true" list="my-list-id"
              autocomplete="off-codice-prestazione"></b-form-input>
          </span>
        </div>
      </template>
      <template v-slot:cell(descrizionePrestazione)="row">
        <div v-if="row.item.new">
          <b-input-group>
            <b-form-input v-model="prestazione.descrizionePrestazione" list="my-list-id"
              autocomplete="off-descrizione-prestazione" :disabled="!isRowEdit(row)">
            </b-form-input>
            <datalist id="my-list-id" v-if="completeBookingSsn">
              <option v-for="(item, i) in prestazioniOptions" :key="i" :value="item.descrizionePrestazione">
                {{ `${item.descrizionePrestazione}` }}
              </option>
            </datalist>
            <datalist id="my-list-id" v-else>
              <option v-for="(item, i) in prestazioniOptions" :key="i" :value="item.descrizione">
                {{ `${item.descrizione}` }}
              </option>
            </datalist>
          </b-input-group>
        </div>
        <div v-else>
          <div v-if="!isRowEdit(row)">

            <b-form-input v-model="selectedRowEditItem.descrizionePrestazione" list="my-list-id"
              autocomplete="off-descrizione-prestazione"></b-form-input>
            <datalist id="my-list-id">
              <option v-for="(item, i) in prestazioniOptions" @change="onChangePrestazione()" :key="i"
                :value="item.descrizionePrestazione">
                {{ `${item.descrizionePrestazione}` }}
              </option>
            </datalist>
          </div>
          <span v-else>
            <b-form-input v-model="row.item.descrizionePrestazione" :disabled="true" list="my-list-id"
              autocomplete="off-descrizione-prestazione"></b-form-input>
          </span>
        </div>
      </template>
      <template v-slot:cell(quantitaErogabile)="row">
        <div>
          <b-form-input :value="row.item.quantitaErogabile" type="text" :disabled="true"></b-form-input>
        </div>

      </template>
      <template v-slot:cell(prezzo)="row">
        <div v-if="row.item.new">
          <b-form-input v-model="prestazione.prezzo" type="text" :disabled="completeBookingSsn"></b-form-input>
        </div>
        <div v-else>
          <b-form-input v-model="selectedRowEditItem.prezzo" type="text" :disabled="completeBookingSsn"
            v-if="!isRowEdit(row)"></b-form-input>

          <b-form-input v-else :value="row.item.prezzo + ' €'" :disabled="true"></b-form-input>
        </div>
      </template>
      <template v-slot:cell(dataErogazione)="row">
        <div v-if="row.item.new">
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="prestazione.dataErogazione"
            type="date"></date-picker>
        </div>
        <span v-else>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="selectedRowEditItem.dataErogazione"
            type="date" v-if="!isRowEdit(row)"></date-picker>
          <span v-else>
            {{ formatDate(row.item.dataErogazione) }}
          </span>
        </span>
      </template>
      <template v-slot:cell(statoAttuale)="row">
        <span v-if="!row.item.new" style="font-weight: 700; margin-right: 3px">
          {{ row.item.statoAttuale }}
        </span>
      </template>
      <template v-slot:cell(actions)="row">
        <!-- stessi pulsanti di AccettazioneSsnImpegnativaComponent -->
        <b-container v-if="row.item.new && selectedRowEditIndex == null" style="gap:8px; display: flex;">
          <template v-if="!isViewer">
            <b-button :disabled="isBtnVisibile('PulisciPrestazione', row)" @click="onClickPulisciPrestazione(row)"
              title="Reset" variant="btn btn-warning waves-effect waves-light width-sm no-text">
              <b-icon icon="arrow-counterclockwise"></b-icon>
            </b-button>
            <b-button :disabled="isBtnVisibile('AggiungiPrestazione', row)" @click="onAggiungiPrestazione(row)"
              title="Aggiungi Prestazione" variant="btn btn-success waves-effect waves-light width-sm no-text">
              <b-icon icon="plus"></b-icon>
            </b-button>
          </template>
        </b-container>
        <b-container v-else style="gap:8px; display: flex;">
          <template v-if="!isRowEdit(row)">
            <b-button @click="onConfermaModificaPrestazione(row)" title="Conferma Modifica"
              variant="btn btn-success waves-effect waves-light width-sm no-text">
              <b-icon icon="check"></b-icon>
            </b-button>
            <b-button @click="onAnnullaModifica(row)" title="Annulla Modifica"
              variant="btn btn-secondary waves-effect waves-light width-sm no-text">
              <b-icon icon="x"></b-icon>
            </b-button>
          </template>
          <b-button v-if="!isModificaRecordPrestazione && row.item.appuntamenti.length > 0"
            @click="onVisualizzaPrenotazione(row)" title="Visualizza Appuntamenti"
            variant="btn btn-info waves-effect waves-light width-sm no-text">
            <b-icon icon="eye"></b-icon>
          </b-button>
          <b-button v-if="isBtnVisibile('PrenotaVisita', row)" @click="onPrenotaAppuntamento(row)"
            title="Prenota Appuntamenti" variant="btn btn-primary waves-effect waves-light width-sm no-text">
            <b-icon icon="calendar-plus"></b-icon>
          </b-button>
          <b-button v-if="selectedRowEditIndex == null && !isViewer" :disabled="row.item.appuntamenti.length > 0"
            @click="onEliminaPrestazione(row)" title="Rimuovi Prestazione"
            variant="btn btn-danger waves-effect waves-light width-sm no-text">
            <font-awesome-icon :icon="'trash'" />
          </b-button>
        </b-container>
      </template>
    </b-table>
    <!-- prenotazione slot da agenda -->
    <b-modal ref="mdlPrenotazionePrestazione" scrollable size="xl" title="Prenotazione Appuntamenti"
      @hide="onHideModalPrenotazione">
      <template v-if="selectedRowPrenotazione">
        <div class="ft-ga-riepilogo">
          <span class="ft-ga-riepilogo-icon"><b-icon icon="calendar2-week"></b-icon></span>
          <div class="ft-ga-riepilogo-testo">
            <div class="ft-ga-riepilogo-titolo">
              {{ selectedRowPrenotazione.item.descrizionePrestazione }}
              <span class="ft-ga-codice" v-if="selectedRowPrenotazione.item.codicePrestazione">{{
                selectedRowPrenotazione.item.codicePrestazione }}</span>
            </div>
            <div class="ft-ga-riepilogo-sub" v-if="accettazioneJson.accettazioneAnagrafica">
              <b-icon icon="person"></b-icon>
              {{ accettazioneJson.accettazioneAnagrafica.cognome }} {{ accettazioneJson.accettazioneAnagrafica.nome }}
              {{ accettazioneJson.accettazioneAnagrafica.identificativo }}
            </div>
          </div>
          <div class="ft-pallini">
            <div class="ft-pallino-box">
              <label>Eseguiti</label>
              <span class="ft-pallino ft-pallino-eseguiti">{{ getNumber('ESEGUITO', disponbilitaSelezionate) }}</span>
            </div>
            <div class="ft-pallino-box">
              <label>Prenotati</label>
              <span class="ft-pallino ft-pallino-prenotati">{{ getNumber('PRENOTATO', disponbilitaSelezionate) }}</span>
            </div>
            <div class="ft-pallino-box">
              <label>Ciclo</label>
              <span class="ft-pallino ft-pallino-ciclo">{{ selectedRowPrenotazione.item.quantitaErogabile }}</span>
            </div>
          </div>
          <div class="ft-ga-step">
            <span :class="['ft-ga-step-item', { 'is-active': tab == 1 }]">1 Seleziona</span>
            <b-icon icon="chevron-right" class="ft-ga-step-sep"></b-icon>
            <span :class="['ft-ga-step-item', { 'is-active': tab == 2 }]">2 Conferma</span>
          </div>
        </div>

        <b-row v-if="tab == 1">
          <!-- disponibilità del giorno -->
          <b-col cols="12" lg="7" class="mb-3">
            <div class="ft-ga-sezione ft-ga-sezione-fissa">
              <div class="ft-ga-sezione-titolo">Disponibilità</div>
              <b-row>
                <b-col cols="12" md="6">
                  <label class="sa-label-data">Agenda</label>
                  <b-form-select v-model="idAgenda" :options="agendeOptions" value-field="id" text-field="titolo">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col cols="12" md="6">
                  <label class="sa-label-data">Data</label>
                  <div class="ft-ga-data-nav">
                    <b-button variant="outline-secondary" size="sm" title="Giorno precedente" @click="indietro">
                      <b-icon icon="chevron-left"></b-icon>
                    </b-button>
                    <date-picker v-model="dataRiferimentoDate" format="DD-MM-YYYY" value-type="timestamp"
                      placeholder="Seleziona Data" type="date" :clearable="false" class="flex-grow-1"></date-picker>
                    <b-button variant="outline-secondary" size="sm" title="Giorno successivo" @click="avanti">
                      <b-icon icon="chevron-right"></b-icon>
                    </b-button>
                    <b-button variant="outline-secondary" size="sm" title="Oggi" @click="onTornaAdOggi">Oggi</b-button>
                  </div>
                </b-col>
              </b-row>

              <div class="ft-ga-giorno">{{ getGiornoSettimana(dataRiferimento) }} {{ formattaData(dataRiferimento) }}
              </div>
              <div v-if="isCicloEseguito" class="ft-ga-avviso ft-ga-avviso-concluso">
                <b-icon icon="check-circle-fill"></b-icon>
                Ciclo completo ({{ disponbilitaSelezionate.length }}/{{ selectedRowPrenotazione.item.quantitaErogabile }})
              </div>
              <div v-else-if="isCicloCompleto" class="ft-ga-avviso ft-ga-avviso-info">
                <b-icon icon="info-circle-fill"></b-icon>
                Ciclo completo ({{ disponbilitaSelezionate.length }}/{{ selectedRowPrenotazione.item.quantitaErogabile }}):
                per scegliere un altro slot elimina prima un appuntamento.
              </div>
              <div v-if="idAgenda && appuntamentoGiornoCorrente" class="ft-ga-avviso">
                <b-icon icon="exclamation-triangle-fill"></b-icon>
                Appuntamento già presente in questo giorno (N° {{ appuntamentoGiornoCorrente.numeroOrdine }}, ore
                {{ appuntamentoGiornoCorrente.dalleOre }}): è consentito un solo appuntamento al giorno.
              </div>
              <div class="ft-ga-slots">
                <button v-for="(slot, i) in slotDisponibili" :key="i" type="button"
                  :class="['ft-ga-slot', { 'is-selected': isActiveClassCard(slot), 'is-disabled': appuntamentoGiornoCorrente && !isActiveClassCard(slot) }]"
                  @click="onClickDisponibilita(slot)">
                  <span class="ft-ga-slot-ora">{{ getFasciaSlot(slot) }}</span>
                </button>
                <div v-if="slotDisponibili.length == 0" class="ft-ga-vuoto">
                  {{ idAgenda ? "Nessuno slot disponibile per la data selezionata" : "Seleziona un'agenda" }}
                </div>
              </div>
            </div>
          </b-col>

          <!-- slot scelti -->
          <b-col cols="12" lg="5" class="mb-3">
            <div class="ft-ga-sezione ft-ga-sezione-fissa">
              <div class="ft-ga-sezione-titolo">Appuntamenti selezionati</div>
              <div class="ft-ga-selezionati">
                <div v-for="(selezione, index) in disponbilitaSelezionate" :key="index"
                  :class="['ft-ga-selezionato', getClassColorBorder(selezione)]">
                  <span class="ft-ga-numero">{{ selezione.numeroOrdine }}</span>
                  <div class="flex-grow-1">
                    <div class="ft-ga-data">{{ formattaData(selezione.dataRiferimento) }}
                      <small>{{ getGiornoSettimana(selezione.dataRiferimento) }}</small>
                    </div>
                    <div class="ft-ga-ora">{{ getFasciaSlot(selezione) }}</div>
                    <div v-if="getAgendaSelezione(selezione)" class="ft-ga-sel-agenda"
                      :title="getAgendaSelezione(selezione)">
                      <b-icon icon="journal-medical"></b-icon> {{ getAgendaSelezione(selezione) }}
                    </div>
                    <div v-else class="ft-ga-sel-agenda is-vuota">
                      <b-icon icon="journal-medical"></b-icon> Agenda non assegnata
                    </div>
                  </div>
                  <span class="ft-ga-stato">{{ selezione.statoAttuale }}</span>
                  <!-- stessi pulsanti di AccettazioneSsnImpegnativaComponent -->
                  <b-button v-if="!selezione.id" @click="onClickDisponibilita(selezione)" title="Rimuovi selezione"
                    variant="btn btn-secondary waves-effect waves-light width-sm no-text">
                    <b-icon icon="x"></b-icon>
                  </b-button>
                  <b-button v-else-if="isAppuntamentoEliminabile(selezione)" @click="onClickEliminaAppuntamento(selezione)"
                    title="Elimina appuntamento" variant="btn btn-danger waves-effect waves-light width-sm no-text">
                    <font-awesome-icon :icon="'trash'" />
                  </b-button>
                </div>
                <div v-if="disponbilitaSelezionate.length == 0" class="ft-ga-vuoto">Nessun appuntamento selezionato
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- conferma -->
        <div v-if="tab == 2" class="ft-ga-sezione ft-ga-sezione-fissa">
          <div class="ft-ga-riepilogo-header">
            <div class="ft-ga-sezione-titolo mb-0">Riepilogo appuntamenti</div>
            <div class="ft-ga-agenda" v-if="getTitoloAgenda(idAgenda)">
              <b-icon icon="journal-medical"></b-icon> Agenda: <b>{{ getTitoloAgenda(idAgenda) }}</b>
            </div>
          </div>
          <div class="ft-ga-tabella-riepilogo">
            <table>
              <thead>
                <tr>
                  <th style="width: 3rem">N°</th>
                  <th>Data</th>
                  <th>Giorno</th>
                  <th>Orario</th>
                  <th>Agenda</th>
                  <th class="text-right">Stato</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(selezione, index) in disponbilitaSelezionate" :key="index"
                  :class="getClassColorBorder(selezione)">
                  <td><span class="ft-ga-numero">{{ selezione.numeroOrdine }}</span></td>
                  <td class="ft-ga-data">{{ formattaData(selezione.dataRiferimento) }}</td>
                  <td class="ft-ga-giorno-cella">{{ getGiornoSettimana(selezione.dataRiferimento) }}</td>
                  <td class="ft-ga-ora">{{ getFasciaSlot(selezione) }}</td>
                  <td>{{ getAgendaSelezione(selezione) || getTitoloAgenda(idAgenda) || '--' }}</td>
                  <td class="text-right">
                    <span :class="['ft-ga-badge-stato', selezione.id ? getClassColorBorder(selezione) : 'ft-stato-nuovo']">
                      {{ selezione.id ? selezione.statoAttuale : 'NUOVO' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100" style="gap: 6px">
          <b-button variant="secondary" v-if="tab == 1" @click="closeModal">Chiudi</b-button>
          <b-button variant="secondary" v-if="tab == 2" @click="tab = 1">Indietro</b-button>
          <b-button variant="primary" v-if="tab == 1" :disabled="disponbilitaSelezionate.length == 0"
            @click="tab = 2">Avanti <b-icon icon="chevron-right"></b-icon></b-button>
          <b-button variant="success" v-if="tab == 2" @click="onOkConfermaAppuntamento">
            <b-icon icon="check2"></b-icon> Prenota
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- visualizzazione appuntamenti / accessi della prestazione -->
    <b-modal ref="mdlVisualizzaPrenotazione" size="lg" :title="completeBookingSsn ? 'Appuntamenti' : 'Accessi'">
      <div class="ft-ga-sezione">
        <div class="ft-ga-sezione-titolo">{{ completeBookingSsn ? 'Slot occupati' : 'Accessi eseguiti' }}</div>
        <div class="ft-appuntamenti-griglia">
          <accettazione-ssn-appuntamento-card-component v-for="(appuntamento, index) in appuntamentiViewOrdinati"
            :key="appuntamento.id || index" :appuntamento="appuntamento" />
          <div v-if="appuntamentiViewOrdinati.length == 0" class="ft-ga-vuoto">Nessun appuntamento</div>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeModalViewAppuntamento">Chiudi</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import toast from "../../../../template/layout/utility/sa-toast";
import PresidiPrestazioniMixins from "../../../strutture/presidiprestazioni/mixins/PresidiPrestazioniMixins"
import axios from "axios";
import AccettazioneSsnAppuntamentoCardComponent from "./AccettazioneSsnAppuntamentoCardComponent.vue";
export default {
  mixins: [UtilityMixin, PresidiPrestazioniMixins],
  props: {
    tipologiaRicetta: {
      type: [String, Object],
      default: null
    },
    prestazioniRicetta: {
      type: Array,
      default: () => { return [] }
    }
    ,
    isViewer: {
      type: Boolean,
      default: () => { return false }
    }
  },
  components: { DatePicker, AccettazioneSsnAppuntamentoCardComponent },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  computed: {
    isCicloCompleto() {
      return !!this.selectedRowPrenotazione && this.disponbilitaSelezionate.length >= this.selectedRowPrenotazione.item.quantitaErogabile;
    },
    // ciclo completo e tutti gli appuntamenti eseguiti: non c'è nulla da eliminare
    isCicloEseguito() {
      return this.isCicloCompleto && this.disponbilitaSelezionate.every((app) => app.statoAttuale === "ESEGUITO");
    },
    // appuntamento (salvato o appena scelto) già presente nel giorno mostrato
    appuntamentoGiornoCorrente() {
      return this.getAppuntamentoDelGiorno(this.dataRiferimento);
    },
    // appuntamenti della modale "Visualizza" in ordine cronologico
    appuntamentiViewOrdinati() {
      return [...(this.appuntamentoView || [])].sort((a, b) => (Number(a.dataOraInizio) || 0) - (Number(b.dataOraInizio) || 0));
    },
    prestazioniItems() {
      if (this.isViewer) {
        return [...this.itemsPrestazioni];
      } else {
        return [...this.itemsPrestazioni, this.prestazione]
      }


    },
    slotDisponibili() {
      return [...this.disponibilitaAgenda[0].disponibilita];
    },
    disponibilitaAgenda() {
      let me = this;
      let returnValue = [
        {
          giorno: me.dataRiferimento,
          disponibilita: [],
        },
      ];
      if (me.disponibilitaAgendaItems != null)
        if (me.disponibilitaAgendaItems[0]) {
          let disponibilita = me.disponibilitaAgendaItems[0].disponibilita;
          for (let dis of disponibilita) {
            let listaAccessi = dis.appuntamento.length;
            for (let i = 0; i < listaAccessi; i++) {
              let slotDisp = false;
              if (dis.appuntamento[i] === null) {
                slotDisp = true;
              }
              if (slotDisp) {
                const dataI = new Date(`${dis.dataRiferimento}T${dis.dalleOre}`);
                if (new Date() < dataI) {
                  returnValue[0].disponibilita.push(dis);
                }
              }
            }
          }
          returnValue[0].disponibilita = new Set(returnValue[0].disponibilita);

        }

      return returnValue;
    },
  },
  mounted() {
    this.selectedRowDetail = null;
    this.selectedRowEditIndex = null;
    this.selectedRowEditItem = null;
    this.dataRiferimento = moment(new Date().getTime()).format("YYYY-MM-DD");
    if (!this.completeBookingSsn) {
      this.headersPrestazioni = this.headersPrestazioni.filter(e => e.key != 'quantitaErogabile' && e.key != 'statoAttuale' && e.key != 'quantita')
      let appuntamenti = this.headersPrestazioni.find(e => e.key == 'appuntamenti')
      appuntamenti.label = ''
    }

  },
  data() {
    return {
      localData: {},
      dataRiferimentoDate: new Date().getTime(),
      selectedRowEditIndex: null,
      selectedRowEditItem: null,
      accettazioneJson: {},
      itemsPrestazioni: [],
      isModificaRecordPrestazione: false,
      prestazioniOptions: [],
      pathResourcePrestazioni: "/agendaprestazioni/presidio",
      pathResourceAgenda: "/agende/prestazione",
      pathResourceAgendaDisponibilita: "/agendadisponibilita",
      pathResourceAgendaAppuntamento: "/agendaappuntamenti",
      dataRiferimento: "",
      headersPrestazioni: [
        {
          label: "Quantita",
          key: "quantita",
          thStyle: "width: 2rem",
        },
        {
          label: "Cod.Prestazione",
          key: "codicePrestazione",
          thStyle: "width: 5rem",
        },
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
        },
        {
          label: "Erogabile",
          key: "quantitaErogabile",
          thStyle: "width: 6rem",
        },
        {
          label: "Prezzo",
          key: "prezzo",
          thStyle: "width: 6rem",
        },
        {
          label: "Stato Prestazione",
          key: "statoAttuale",
        },

        {
          label: "Slots",
          key: "appuntamenti",
          thStyle: "width: 12rem",
          tdClass: "d-flex align-items-center justify-content-center"

        },

        /**    {
          label: "Data Erogazione",
          key: "dataErogazione",
        },*/
        {
          label: "",
          key: "actions",
          class: "sa-table-column-action-double",
          thStyle: "width: 8rem",
          thClass: "text-right",
          tdClass: "text-right"
        }
      ],
      tab: 1,
      disponibilitaAgendaItems: [],
      disponbilitaSelezionate: [],
      agendeOptions: [],
      idAgenda: null,
      prestazione: {
        id: "-1",
        quantita: 1,
        idListino: "---",
        descrizionePrestazione: null,
        codicePrestazione: null,
        statoAttuale: "PRESA IN CARICO",
        prezzo: 0,
        dataErogazione: null,
        new: true,
        appuntamenti: [],
      },
      periodoAgenda: "G",
      appuntamentoView: [],
      selectedRowPrenotazione: null,
      completeBookingSsn: this.appConfig.completeBookingSSN,
    };
  },
  methods: {
    init(jsonData, accettazioneJson) {
      this.accettazioneJson = accettazioneJson;
      if (jsonData) {
        this.localData = jsonData;
        this.itemsPrestazioni = this.localData.prestazioni;
      }
      if (this.completeBookingSsn) {
        this.loadPrestazioniAgendaPresidio();
      } else {
        this.loadPrestazioniStrutturaPresidio(this.accettazioneJson?.accettazionePresidio?.codicePresidio);
      }
    },
    getNumber(stato, appuntamenti) {
      if (!appuntamenti) {
        return 0;
      }
      return appuntamenti.filter(a => a.statoAttuale === stato).length;

    },
    loadPrestazioniStrutturaPresidio(codicePresidio) {

      PresidiPrestazioniMixins.methods.loadPrestazioniPresidioByCodicePresidio(codicePresidio, this.successCallPrestazioniPresidio)

    },
    successCallPrestazioniPresidio(response) {
      this.prestazioniOptions = response.data.data.list;

    },

    getClassColorBorder(row) {
      if (!row.statoAttuale) {
        return;
      }
      switch (row.statoAttuale) {
        case "PRENOTATO":
          return 'ft-stato-prenotato';
        case "ESEGUITO":
          return 'ft-stato-eseguito';
        default:
          return 'ft-stato-altro'
      }
    },

    onChangePrestazione(e) {
      console.log("change prestazione", e);

    },
    onClickPulisciPrestazione(row) {
      let item = row.item;

      item.prezzo = 0;
      item.quantita = 1;
      item.quantitaErogabile = 0;
      item.descrizionePrestazione = null;
      item.codicePrestazione = null;

    },
    getGiornoSettimana(dataString) {
      if (!dataString) return "";
      return moment(dataString).locale('it').format('dddd');
    },
    formattaData(data) {
      if (!data) return "--";
      return moment(data).format("DD/MM/YYYY");
    },
    // "09:00 - 09:30", oppure solo "09:00" se inizio e fine coincidono
    getFasciaSlot(slot) {
      return !slot.alleOre || slot.dalleOre === slot.alleOre ? slot.dalleOre : slot.dalleOre + " - " + slot.alleOre;
    },
    getTitoloAgenda(idAgenda) {
      const agenda = this.agendeOptions.find((a) => a.id == idAgenda);
      return agenda ? agenda.titolo : null;
    },
    // titolo dell'agenda di un appuntamento selezionato: dalle agende caricate, altrimenti dal titolo dell'appuntamento
    getAgendaSelezione(selezione) {
      const titolo = selezione.idAgenda ? this.getTitoloAgenda(selezione.idAgenda) : null;
      if (titolo) return titolo;
      return selezione.titolo && selezione.titolo != "ACCESSI" ? selezione.titolo : null;
    },
    onPrenotaAppuntamento(row) {
      let me = this;
      me.selectedRowPrenotazione = row;
      let appuntamenti = [];

      if (row.item.appuntamentiTmp && row.item.appuntamentiTmp.length > 0) {
        appuntamenti = JSON.parse(JSON.stringify(row.item.appuntamentiTmp));
      } else if (row.item.appuntamenti && row.item.appuntamenti.length > 0) {
        appuntamenti = JSON.parse(JSON.stringify(row.item.appuntamenti));
      }
      me.disponbilitaSelezionate = appuntamenti;
      me.loadAgende();
      me.$refs.mdlPrenotazionePrestazione.show();
    },
    isBtnVisibile(key, row) {
      switch (key) {
        case "PrenotaVisita":
          // visibile anche a ciclo completo: si possono rivedere/eliminare gli appuntamenti e scegliere l'agenda
          // (es. appuntamenti recuperati da NRE); l'aggiunta oltre la quantità erogabile resta bloccata nella modale.
          // In visualizzazione (occhio) resta solo "Visualizza"
          return !this.isViewer && row.item.quantitaErogabile > 0 && this.selectedRowEditItem == null;
        case "AggiungiPrestazione":
          return row.item.descrizionePrestazione == null || row.item.descrizionePrestazione == '';
        case "PulisciPrestazione":
          return (row.item.descrizionePrestazione == null || row.item.descrizionePrestazione == '')
        default:
          return false;
      }
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    loadAgende() {
      let me = this;
      me.agendeOptions = [];
      UtilityMixin.methods.loadDataResources(me.pathResourceAgenda, { idPresidio: me.accettazioneJson.idPresidio, codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione }, me.loadAgendeSuccess, me.loadAgendeError);
    },
    loadAgendeSuccess(response) {
      this.agendeOptions = response.data.data || [];
      // con una sola agenda disponibile la si seleziona direttamente
      if (this.agendeOptions.length === 1) {
        this.idAgenda = this.agendeOptions[0].id;
      }
    },
    loadAgendeError(error) {
      toast.error(error?.response?.data?.messaggio);
    },
    onHideModalPrenotazione() {
      this.tab = 1;
      this.idAgenda = null;
      this.disponibilitaAgendaItems = [];
      this.disponbilitaSelezionate = [];
    },
    isRowEdit(row) {
      let me = this;
      return row == null ? true : row.index == me.selectedRowEditIndex ? false : true;
    },
    closeModalViewAppuntamento() {
      let me = this;
      me.$refs.mdlVisualizzaPrenotazione.hide();
    },
    onVisualizzaPrenotazione(row) {
      let me = this;
      me.appuntamentoView = row.item.appuntamenti;
      me.$refs.mdlVisualizzaPrenotazione.show();
    },
    onModificaPrestazione(row) {
      let me = this;

      if (me.selectedRowEditIndex == null) {
        this.isModificaRecordPrestazione = true;
        me.selectedRowEditIndex = row.index;
        me.selectedRowEditItem = JSON.parse(JSON.stringify(row.item));
      }
    },

    onAnnullaModifica() {
      let me = this;
      me.selectedRowEditIndex = null;
      me.selectedRowEditItem = null;
      this.isModificaRecordPrestazione = false;
    },
    closeModal() {
      let me = this;
      me.$refs.mdlPrenotazionePrestazione.hide();
    },
    onConfermaModificaPrestazione() {
      let me = this;
      if (me.selectedRowEditIndex != null) {
        //let nuovaQuantita = Number(me.selectedRowEditItem.quantita);

        if (me.selectedRowEditItem.quantita == 0) {
          toast.warning("Quantita Selezionata non può essere 0 !")
          return;
        }

        console.log("selezionata ", me.selectedRowEditItem);

        me.$set(me.prestazioniItems, me.selectedRowEditIndex, JSON.parse(JSON.stringify(me.selectedRowEditItem)));
        me.selectedRowEditIndex = null;


        me.selectedRowEditItem = null;
        this.isModificaRecordPrestazione = false;


      }
      this.localData.prestazioni = me.prestazioniItems.filter((e) => e.new != true);
      this.$emit("updatePrestazioni", this.localData.prestazioni);
    },

    onEliminaPrestazione(row) {
      let prestazioneRicetta = row.item;

      this.$bvModal
        .msgBoxConfirm("Sei sicuro di voler eliminare la prestazione dalla ricetta ?", {
          title: "Eliminazione Prestazione Ricetta",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.prestazioniItems.splice(row.index, 1);
            this.localData.prestazioni = this.prestazioniItems.filter((e) => e.new != true);
            this.$emit("updatePrestazioni", this.localData.prestazioni);
            if (prestazioneRicetta.id && prestazioneRicetta.id != '-1') {
              this.eliminaPrestazioneRicetta(prestazioneRicetta);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });



    },
    eliminaPrestazioneRicetta(pr) {
      this.openShowModalLoading();
      let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + pr.id;
      axios.delete(link).then(() => {
        toast.success("Eliminato con successo !")
        this.closeShowModalLoading();
      }).catch((err) => {
        this.closeShowModalLoading();
        toast.error(err?.response?.data?.messaggio);
      });

    },
    isActiveClassCard(disponibilita) {
      if (!this.disponbilitaSelezionate || this.disponbilitaSelezionate.length === 0) return false;

      return this.disponbilitaSelezionate.some((e) => {
        let a = e.alleOre === disponibilita.alleOre;
        let b = e.dalleOre === disponibilita.dalleOre;

        // Normalizziamo le date usando moment per essere sicuri del formato YYYY-MM-DD
        let dateA = moment(e.dataRiferimento).format("YYYY-MM-DD");
        let dateB = moment(disponibilita.dataRiferimento).format("YYYY-MM-DD");
        let c = dateA === dateB;

        return a && b && c;
      });
    },
    onOkConfermaAppuntamento() {
      let me = this;
      // 1. Creiamo un nuovo array temporaneo pulito
      let nuoviAppuntamenti = [];

      for (let disponibilita of me.disponbilitaSelezionate) {
        if (!disponibilita.id) {
          let dataInizio = new Date(disponibilita.dataRiferimento);
          let dataFine = new Date(disponibilita.dataRiferimento);
          const [oreInizio, minInizio] = disponibilita.dalleOre.split(':').map(Number);
          const [oreFine, minFine] = disponibilita.alleOre.split(':').map(Number);
          let dataOraInizio = dataInizio.setHours(oreInizio, minInizio, 0, 0);
          let dataOraFine = dataFine.setHours(oreFine, minFine, 0, 0);
          let appuntamentoAgenda = {
            idAgenda: disponibilita.idAgenda || me.idAgenda,
            cognome: me.accettazioneJson.accettazioneAnagrafica.cognome,
            tipoIdentificativo: "CF",
            identificativoAppuntamento: me.accettazioneJson.accettazioneAnagrafica.identificativo,
            codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione,
            descrizionePrestazione: me.selectedRowPrenotazione.item.descrizionePrestazione,
            dataOraInizio: dataOraInizio,
            dataOraFine: dataOraFine,
            dalleOre: disponibilita.dalleOre,
            alleOre: disponibilita.alleOre,
            dataRiferimento: disponibilita.dataRiferimento,
            costo: me.selectedRowPrenotazione.item.prezzo,
            nome: me.accettazioneJson.accettazioneAnagrafica.nome,
            dataNascita: null,
            statoAttuale: disponibilita.statoAttuale,
            note: null,
            numeroOrdine: disponibilita.numeroOrdine
          };
          nuoviAppuntamenti.push(appuntamentoAgenda);
        } else {
          nuoviAppuntamenti.push(JSON.parse(JSON.stringify(disponibilita)));
        }
      }
      me.selectedRowPrenotazione.item.appuntamenti = nuoviAppuntamenti;
      me.$refs.mdlPrenotazionePrestazione.hide();
    },

    // un appuntamento già eseguito (o marcato non eseguito) non si può eliminare
    isAppuntamentoEliminabile(appuntamento) {
      return appuntamento.statoAttuale !== "ESEGUITO" && appuntamento.statoAttuale !== "NON ESEGUITO";
    },
    onClickEliminaAppuntamento(appuntamento) {
      this.$bvModal
        .msgBoxConfirm("Eliminare l'appuntamento del " + this.formattaData(appuntamento.dataRiferimento) + " ore " + appuntamento.dalleOre + "?", {
          title: "Eliminazione Appuntamento",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((conferma) => {
          if (conferma) {
            this.eliminaAppuntamento(appuntamento);
          }
        });
    },
    eliminaAppuntamento(appuntamento) {
      this.openShowModalLoading();
      axios
        .delete(process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/" + appuntamento.id)
        .then(() => {
          this.closeShowModalLoading();
          toast.success("Appuntamento eliminato");
          // tolto sia dalla selezione della modale sia dalla prestazione, poi si rinumerano gli accessi
          this.disponbilitaSelezionate = this.disponbilitaSelezionate.filter((e) => e.id !== appuntamento.id);
          this.disponbilitaSelezionate.forEach((e, index) => {
            e.numeroOrdine = index + 1;
          });
          const prestazione = this.selectedRowPrenotazione.item;
          prestazione.appuntamenti = (prestazione.appuntamenti || []).filter((e) => e.id !== appuntamento.id);
        })
        .catch((err) => {
          this.closeShowModalLoading();
          toast.error(err?.response?.data?.messaggio);
        });
    },
    // giorno in formato YYYY-MM-DD, in ora locale (sia da stringa sia da timestamp)
    getGiorno(data) {
      return data ? moment(data).format("YYYY-MM-DD") : null;
    },
    getAppuntamentoDelGiorno(data) {
      const giorno = this.getGiorno(data);
      return this.disponbilitaSelezionate.find((e) => this.getGiorno(e.dataRiferimento) === giorno);
    },
    onClickDisponibilita(item) {
      let me = this;
      const giornoItem = me.getGiorno(item.dataRiferimento);
      const indexSelezionato = me.disponbilitaSelezionate.findIndex((e) => {
        return e.dalleOre === item.dalleOre &&
          e.alleOre === item.alleOre &&
          me.getGiorno(e.dataRiferimento) === giornoItem;
      });

      if (indexSelezionato !== -1) {
        if (me.disponbilitaSelezionate[indexSelezionato].id) {
          toast.warning("Non e possibile rimuovere un appuntamento salvato, procedere all'eliminazione dall'interfaccia o sposta appuntamento")
          return;
        } else {
          me.disponbilitaSelezionate.splice(indexSelezionato, 1);
        }
      } else {
        // un solo appuntamento al giorno, altrimenti la numerazione degli accessi non è più coerente
        const appuntamentoDelGiorno = me.getAppuntamentoDelGiorno(item.dataRiferimento);
        if (appuntamentoDelGiorno) {
          toast.warning("È già presente un appuntamento il " + me.formattaData(giornoItem) + " alle " + appuntamentoDelGiorno.dalleOre + ": è consentito un solo appuntamento al giorno");
          return;
        }
        const quantitaErogabile = this.selectedRowPrenotazione.item.quantitaErogabile;
        if (me.disponbilitaSelezionate.length < quantitaErogabile) {
          item.statoAttuale = "PRENOTATO";
          // lo slot ricorda l'agenda da cui è stato scelto
          item.idAgenda = me.idAgenda;
          me.disponbilitaSelezionate.push(item);
        } else {
          toast.warning("Numero Totale Erogabile è di " + quantitaErogabile);
          return;
        }
      }

      me.disponbilitaSelezionate = me.disponbilitaSelezionate.sort((a, b) => {
        const dataA = new Date(`${me.getGiorno(a.dataRiferimento)}T${a.dalleOre}`);
        const dataB = new Date(`${me.getGiorno(b.dataRiferimento)}T${b.dalleOre}`);
        return dataA - dataB;
      });
      me.disponbilitaSelezionate.forEach((appuntamento, index) => {
        const numeroAppuntamento = index + 1;
        appuntamento.numeroOrdine = numeroAppuntamento;
      });
    },
    onAggiungiPrestazione(row) {

      if (!this.completeBookingSsn) {
        let prestazione = row.item;
        let prestazioneGiaSelezioanta = this.prestazioniRicetta.find(e => e.descrizionePrestazione == prestazione.descrizionePrestazione)
        if (prestazioneGiaSelezioanta) {
          toast.warning(`${row.item.descrizionePrestazione} già selezionata !`)
          return;
        }
        let prestazioneSelezionata = this.prestazioniOptions.find(e => e.descrizione == prestazione.descrizionePrestazione)
        if (!prestazioneSelezionata) {
          toast.warning("Selezionare da elenco prestazione valida !")
          return;
        }
        prestazione.codicePrestazione = prestazioneSelezionata.codice;
        prestazione.prezzo = prestazioneSelezionata.prezzo;
      }
      this.$emit("onAggiungiPrestazione", row);
      this.resetPrestazione();
    },
    // la data si cambia solo da dataRiferimentoDate: il watcher aggiorna dataRiferimento e ricarica gli slot
    onTornaAdOggi() {
      this.dataRiferimentoDate = new Date().getTime();
    },
    indietro() {
      this.dataRiferimentoDate = moment(this.dataRiferimentoDate).subtract(1, "days").valueOf();
    },
    avanti() {
      this.dataRiferimentoDate = moment(this.dataRiferimentoDate).add(1, "days").valueOf();
    },
    resetPrestazione() {
      this.prestazione = {
        quantita: 1,
        idListino: "---",
        prezzo: 0,
        quantitaErogabile: 0,
        statoAttuale: "PRESA IN CARICO",
        descrizionePrestazione: null,
        codicePrestazione: null,
        dataErogazione: null,
        new: true,
        appuntamenti: [],
      };
    },
    loadPrestazioniAgendaPresidio() {
      let me = this;
      me.prestazioniOptions = [];
      if (me.accettazioneJson.idPresidio) {
        this.openShowModalLoading();
        UtilityMixin.methods.loadDataResources(me.pathResourcePrestazioni, { idPresidio: me.accettazioneJson.idPresidio }, me.loadPrestazioniAgendaPresidioSuccess, me.loadPrestazioniAgendaPresidioError);
      } else {
        toast.error("Errore nel recupero della struttura")
      }
    },

    loadPrestazioniAgendaPresidioSuccess(response) {
      let me = this;
      me.prestazioniOptions = response.data.data;
      this.closeShowModalLoading();
    },
    loadPrestazioniAgendaPresidioError(error) {
      console.log(error);
    },
    loadAgendaDisponibilita() {
      let me = this;
      if (me.selectedRowPrenotazione) {
        let itemFIlter = {
          language: "it",
          idAgenda: me.idAgenda,
          periodo: me.periodoAgenda,
          riferimento: me.dataRiferimento,
          codicePrestazione: this.selectedRowPrenotazione.item.codicePrestazione,
        };
        me.disponibilitaAgendaItems = [];
        this.openShowModalLoading();
        UtilityMixin.methods.loadDataResources(me.pathResourceAgendaDisponibilita, itemFIlter, me.loadAgendaDisponibilitaSuccess, me.loadAgendaDisponibilitaError);
      }
    },
    loadAgendaDisponibilitaSuccess(response) {
      let me = this;
      // risposta arrivata dopo la chiusura della modale o il reset dell'agenda: la si ignora
      me.disponibilitaAgendaItems = me.idAgenda ? response.data.data : [];
      this.closeShowModalLoading();
    },
    loadAgendaDisponibilitaError(error) {
      console.log(error);
      this.closeShowModalLoading();
    },
  },
  watch: {
    dataRiferimentoDate: function (params) {
      this.dataRiferimento = moment(params).format("YYYY-MM-DD");
    },
    dataRiferimento: function (params) {
      if (params && this.completeBookingSsn && this.idAgenda) {
        this.loadAgendaDisponibilita();
      }
    },
    idAgenda: function (params) {
      let me = this;
      if (params && this.completeBookingSsn) {
        me.loadAgendaDisponibilita();
      } else {
        // senza agenda non ci sono slot da mostrare
        me.disponibilitaAgendaItems = [];
      }
    },
    "prestazione.quantita": function (params) {
      let me = this;
      if (params >= 1 && me.prestazione.descrizionePrestazione != null && this.completeBookingSsn) {
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === me.prestazione.descrizionePrestazione);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.prestazione.prezzo = prezzoPrestazione * params;
          me.prestazione.codicePrestazione = filter.codicePrestazione;
          me.prestazione.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "prestazione.descrizionePrestazione": function (params) {
      if (params && this.completeBookingSsn) {
        let me = this;
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === params);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.prestazione.prezzo = prezzoPrestazione * me.prestazione.quantita;
          me.prestazione.codicePrestazione = filter.codicePrestazione;
          me.prestazione.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "selectedRowEditItem.quantita": function (params) {
      let me = this;
      console.log("params ", params);

      if (params >= 1 && me.selectedRowEditItem.descrizionePrestazione != null && this.completeBookingSsn) {
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === me.selectedRowEditItem.descrizionePrestazione);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.selectedRowEditItem.prezzo = prezzoPrestazione * params;
          me.selectedRowEditItem.codicePrestazione = filter.codicePrestazione;
          me.selectedRowEditItem.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
    "selectedRowEditItem.descrizionePrestazione": function (params) {
      if (params && this.completeBookingSsn) {
        let me = this;
        let filter = me.prestazioniOptions.find((a) => `${a.descrizionePrestazione}` === params);
        if (filter) {
          let prezzoPrestazione = filter.costo;
          me.selectedRowEditItem.prezzo = prezzoPrestazione * me.selectedRowEditItem.quantita;
          me.selectedRowEditItem.codicePrestazione = filter.codicePrestazione;
          me.selectedRowEditItem.quantitaErogabile = filter.quantitaErogabile;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*
 * Stessa grafica di GestioneAppuntamentoModalComponent (appuntamenti).
 * I colori seguono il tema del cliente (public/css/<cliente>); i valori dopo la virgola sono di riserva.
 */
.ft-ga-riepilogo,
.ft-ga-sezione,
.ft-pallini {
  --ft-accent: var(--bg-sidebar-item, #2ba7bd);
  --ft-border: #e3e8ee;
  --ft-muted: #6c757d;
  --ft-text: #323a46;
  --ft-bg-soft: #f7f9fb;
}

/* ---- pallini eseguiti / prenotati / ciclo ---- */
.ft-pallini {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
}

.ft-pallino-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  label {
    margin-bottom: 2px;
    font-size: 11px;
    color: var(--ft-muted);
  }
}

.ft-pallino {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.ft-pallino-eseguiti {
  background: #218838;
}

.ft-pallino-prenotati {
  background: #ffc107;
}

.ft-pallino-ciclo {
  background: #00a3ff;
}

/* ---- riepilogo prestazione ---- */
.ft-ga-riepilogo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 16px;
  background: var(--ft-bg-soft);
  border: 1px solid var(--ft-border);
  border-left: 4px solid var(--ft-accent);
  border-radius: 8px;
}

.ft-ga-riepilogo-icon {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--ft-border);
  color: var(--ft-accent);
}

.ft-ga-riepilogo-testo {
  flex: 1;
  min-width: 0;
}

.ft-ga-riepilogo-titolo {
  font-weight: 600;
  color: var(--ft-text);
}

.ft-ga-riepilogo-sub {
  font-size: 12px;
  color: var(--ft-muted);
}

.ft-ga-codice {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 4px;
  font-family: var(--font-family-monospace, monospace);
  font-size: 11px;
  color: var(--ft-accent);
  background: #fff;
  border: 1px solid var(--ft-border);
}

.ft-ga-step {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.ft-ga-step-item {
  padding: 3px 10px;
  border-radius: 999px;
  color: var(--ft-muted);
  background: #fff;
  border: 1px solid var(--ft-border);

  &.is-active {
    color: #fff;
    background: var(--ft-accent);
    border-color: var(--ft-accent);
    font-weight: 600;
  }
}

.ft-ga-step-sep {
  color: var(--ft-muted);
}

/* ---- sezioni ---- */
.ft-ga-sezione {
  height: 100%;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--ft-border);
  border-radius: 8px;
}

/* altezza fissa nella modale di prenotazione: la modale non cambia dimensione, scorrono le liste */
.ft-ga-sezione-fissa {
  height: 460px;
  display: flex;
  flex-direction: column;

  .ft-ga-slots,
  .ft-ga-selezionati {
    flex: 1;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
  }
}

/* ---- riepilogo (passo 2) ---- */
.ft-ga-riepilogo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.ft-ga-agenda {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: var(--ft-text);
  background: var(--ft-bg-soft);
  border: 1px solid var(--ft-border);

  .b-icon {
    color: var(--ft-accent);
  }
}

.ft-ga-tabella-riepilogo {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border: 1px solid var(--ft-border);
  border-radius: 6px;

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
  }

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 8px 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: var(--ft-muted);
    background: var(--ft-bg-soft);
    border-bottom: 1px solid var(--ft-border);
  }

  td {
    padding: 6px 10px;
    vertical-align: middle;
    border-bottom: 1px solid var(--ft-border);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover td {
    background: var(--ft-bg-soft);
  }

  /* barra colorata a sinistra in base allo stato */
  tbody tr td:first-child {
    border-left: 3px solid var(--ft-accent);
  }

  tbody tr.ft-stato-prenotato td:first-child {
    border-left-color: #ffc107;
  }

  tbody tr.ft-stato-eseguito td:first-child {
    border-left-color: #28a745;
  }

  tbody tr.ft-stato-altro td:first-child {
    border-left-color: #dc3545;
  }
}

.ft-ga-giorno-cella {
  text-transform: capitalize;
  color: var(--ft-muted);
}

.ft-ga-badge-stato {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  border: 1px solid var(--ft-border);
  color: var(--ft-muted);
  background: #fff;

  &.ft-stato-prenotato {
    color: #a07800;
    background: #fff8e1;
    border-color: #ffe08a;
  }

  &.ft-stato-eseguito {
    color: #1e7e34;
    background: #eaf7ee;
    border-color: #b7e1c1;
  }

  &.ft-stato-altro {
    color: #b02a37;
    background: #fdecee;
    border-color: #f5c2c7;
  }

  &.ft-stato-nuovo {
    color: #fff;
    background: var(--ft-accent);
    border-color: var(--ft-accent);
  }
}

.ft-ga-sezione-titolo {
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--ft-muted);
}

.ft-ga-data-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ft-ga-giorno {
  margin-top: 12px;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--ft-text);
}

/* ---- slot disponibili ---- */
.ft-ga-slots {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
  max-height: 260px;
  margin-top: 8px;
  overflow-y: auto;
}

.ft-ga-slot {
  min-width: 100px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--ft-border);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover {
    border-color: var(--ft-accent);
  }

  &:focus {
    outline: none;
  }

  &.is-selected {
    border-color: var(--ft-accent);
    background: var(--ft-bg-soft);
    box-shadow: 0 0 0 2px var(--ft-accent);
  }

  /* giorno già occupato: gli altri slot non sono selezionabili */
  &.is-disabled {
    opacity: 0.45;
    cursor: not-allowed;

    &:hover {
      border-color: var(--ft-border);
    }
  }
}

.ft-ga-avviso {
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  color: #856404;
  background: #fff8e1;
  border: 1px solid #ffe08a;
}

.ft-ga-avviso-info {
  color: #0c5460;
  background: #e8f6f8;
  border-color: #bee5eb;
}

.ft-ga-avviso-concluso {
  color: #1e7e34;
  background: #eaf7ee;
  border-color: #b7e1c1;
}

.ft-ga-slot-ora {
  font-weight: 600;
  color: var(--ft-text);
  font-variant-numeric: tabular-nums;
}

/* ---- appuntamenti selezionati ---- */
.ft-ga-selezionati {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 330px;
  overflow-y: auto;
}

/* card appuntamenti della modale "Visualizza" (AccettazioneSsnAppuntamentoCardComponent) */
.ft-appuntamenti-griglia {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
}

.ft-ga-sel-agenda {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  color: var(--ft-accent);
}

.ft-ga-sel-agenda.is-vuota {
  font-style: italic;
  color: var(--ft-muted);
}

.ft-ga-selezionato {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid var(--ft-border);
  border-left: 3px solid var(--ft-accent);
  border-radius: 6px;
}

.ft-stato-prenotato {
  border-left-color: #ffc107;
}

.ft-stato-eseguito {
  border-left-color: #28a745;
}

.ft-stato-altro {
  border-left-color: #dc3545;
}

.ft-ga-numero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 11px;
  color: var(--ft-accent);
  background: var(--ft-bg-soft);
  border: 1px solid var(--ft-border);
}

.ft-ga-data {
  font-weight: 600;
  color: var(--ft-text);

  small {
    margin-left: 4px;
    font-weight: 400;
    text-transform: capitalize;
    color: var(--ft-muted);
  }
}

.ft-ga-ora {
  font-size: 12px;
  color: var(--ft-muted);
  font-variant-numeric: tabular-nums;
}

.ft-ga-stato {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--ft-muted);
}

.ft-ga-vuoto {
  font-size: 12px;
  font-style: italic;
  color: var(--ft-muted);
}
</style>
